import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { NotificationProvider } from '@/app/providers/NotificationProvider';
import { LocalizationProvider } from '@/app/providers/LocalizationProvider';
import { StoreProvider } from './app/store';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root was not found');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <LocalizationProvider>
      <StoreProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </StoreProvider>
    </LocalizationProvider>
  </React.StrictMode>,
);
